module.exports = __webpack_public_path__ + "img/Max Steinbok.8af0a626.jpg";